module.exports = __webpack_public_path__ + "04_long_gold.a22eb01c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_long_gold.png
// module id = IxKy
// module chunks = 0